import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/store/hooks";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireFeature?: string;
}

export default function ProtectedRoute({ children, requireAuth = true }: ProtectedRouteProps) {
  const { token } = useAppSelector((state) => state.auth);
  const { profile } = useAppSelector((state) => state.user);

  if (requireAuth && !token) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireAuth && token && !profile) {
    // Wait for profile to load
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return <>{children}</>;
}
